import { withTranslation } from 'react-i18next'
import Password from './Password'

export default withTranslation()(Password)
